module.exports = __webpack_public_path__ + "media/stylesheets/images/temp_wolf_planent_kit/card_kit_4-d5c2032bb3d675e8139423f0f6e9bef2.png";